import userService from 'services/user';

export async function createSupportChatAccountsJwt(ssid: string): Promise<string> {
  const jwtToHyperflow = await userService.createSupportChatToken(ssid);
  const token = jwtToHyperflow?.data?.token;

  if (!token) {
    throw new Error('Token not created or empty');
  }

  return token as string;
}
